import { all, fork, put, select, takeEvery } from 'redux-saga/effects'

import * as actions from './actions'
import { buildConfirmationRequest } from './confirmation'
import {
  selectIsSubmitting,
  selectPendingEnrolments,
  selectUnenrolments,
} from './selectors'

import {
  API_URL,
  ENROLMENT_ENTITLEMENTS_ENROLMENTS_ENDPOINT,
} from 'qap/constants'
import { requestActions } from 'state/request'

export function* confirmDraft(): Generator<any, any, any> {
  const submitting = yield select(selectIsSubmitting)
  if (submitting) return

  const enrolments = yield select(selectPendingEnrolments)
  const unenrolments = yield select(selectUnenrolments)
  const request = buildConfirmationRequest(enrolments, unenrolments)

  yield put({ type: actions.CONFIRM_DRAFT_STARTED })

  // The request goes in the context so a failure can map each error's source
  // (e.g. enrolments[2].participant_id) back to the change it rejects.
  yield put({
    type: requestActions.AUTHED_REQUEST,
    method: 'POST',
    url: `${API_URL}/${ENROLMENT_ENTITLEMENTS_ENROLMENTS_ENDPOINT}`,
    body: { data: request },
    skipGlobalErrorHandling: true,
    successAction: actions.CONFIRM_DRAFT_SUCCEEDED,
    failureAction: actions.CONFIRM_DRAFT_FAILED,
    context: { request },
  })
}

function* watchConfirmDraft(): Generator<any, any, any> {
  yield takeEvery(
    actions.API_ENROLMENT_ENTITLEMENTS_ENROLMENTS_CREATE,
    confirmDraft,
  )
}

export default function* enrolmentDraftSagas(): Generator<any, any, any> {
  yield all([
    fork(watchConfirmDraft),
  ])
}
